<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 fs-6 dialog-title">Keyboard Shortcuts</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>

  <mat-dialog-content>
    <div class="shortcuts-container">
      @for (section of KEYBOARD_SHORTCUTS; track section; let last = $last) {
        <div
          class="shortcut-section"
          [class.last-section]="last">
          <h4 class="section-title">{{ section.section }}</h4>
          <div class="shortcuts-list">
            @for (shortcut of section.shortcuts; track shortcut; let isLast = $last) {
              <div class="shortcut-row" [class.last-row]="isLast">
                <div class="key-cell">
                  <kbd class="shortcut-key">{{ shortcut.key }}</kbd>
                </div>
                <div class="description-cell">{{ shortcut.description }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </mat-dialog-content>
